import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TestimonialsCarousel } from './components/TestimonialsCarousel';
// Lazy-load everything below the fold so the initial bundle stays small.
// The browser paints Hero + Navbar + Testimonial quickly, then streams the rest.
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const ProductOverview = lazy(() => import('./components/ProductOverview').then(m => ({
  default: m.ProductOverview
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const CountdownTimer = lazy(() => import('./components/CountdownTimer').then(m => ({
  default: m.CountdownTimer
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GestionProfesional = lazy(() => import('./components/GestionProfesional').then(m => ({
  default: m.GestionProfesional
})));
const ExtendedTestimonials = lazy(() => import('./components/ExtendedTestimonials').then(m => ({
  default: m.ExtendedTestimonials
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const CostComparison = lazy(() => import('./components/CostComparison').then(m => ({
  default: m.CostComparison
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PurchaseNotification = lazy(() => import('./components/PurchaseNotification').then(m => ({
  default: m.PurchaseNotification
})));
const SectionFallback = () => <div className="min-h-[40vh]" aria-hidden="true" data-id="element-0" />;
export function App() {
  useEffect(() => {
    // Google Search Console verification — sync (cheap)
    if (!document.querySelector('meta[name="google-site-verification"]')) {
      const meta = document.createElement('meta');
      meta.name = 'google-site-verification';
      meta.content = 'PP8aDhyJIXIRVT1gQDZlxllAucfjDugVXIBPQJnRaAw';
      document.head.insertBefore(meta, document.head.firstChild);
    }
    // Defer Meta Pixel until the browser is idle so it doesn't block first paint
    const loadPixel = () => {
      if (typeof window === 'undefined' || (window as any).fbq) return;
      const f = window as any;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      (window as any).fbq('init', '2178960392907335');
      (window as any).fbq('track', 'PageView');
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixel, {
        timeout: 3000
      });
    } else {
      setTimeout(loadPixel, 1500);
    }
  }, []);
  return <div className="min-h-screen bg-charcoal font-sans text-white selection:bg-gold/30" data-id="element-1">
      <noscript data-id="element-2">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2178960392907335&ev=PageView&noscript=1" alt="" data-id="element-3" />
      </noscript>
      <Navbar data-id="element-4" />
      <main data-id="element-5">
        {/* Above the fold — eager */}
        <Hero data-id="element-6" />
        <TestimonialsCarousel data-id="element-7" />

        {/* Below the fold — lazy, streamed in */}
        <Suspense fallback={<SectionFallback data-id="element-9" />} data-id="element-8">
          <ProblemSection data-id="element-10" />
          <ProductOverview data-id="element-11" />
          <BonusSection data-id="element-12" />

          <section className="py-20 bg-charcoal pt-[39px] pb-[39px]" data-id="element-13">
            <CountdownTimer data-id="element-14" />
            <PricingSection data-id="element-15" />
          </section>

          <GestionProfesional data-id="element-16" />
          <ExtendedTestimonials data-id="element-17" />
          <Guarantee data-id="element-18" />
          <FAQ data-id="element-19" />
          <CostComparison data-id="element-20" />
          <FinalCTA data-id="element-21" />
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-22">
        <Footer data-id="element-23" />
        <PurchaseNotification data-id="element-24" />
      </Suspense>
    </div>;
}